import React from 'react';
import Icon from '../../../components/AppIcon';

const InvitationStats = ({ acceptedCount, pendingCount, declinedCount, totalInvitations }) => {
  const calculatePercentage = (count) => {
    if (totalInvitations === 0) return 0;
    return Math.round((count / totalInvitations) * 100);
  };

  const stats = [
    {
      label: 'Accepted',
      count: acceptedCount,
      percentage: calculatePercentage(acceptedCount),
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      label: 'Pending',
      count: pendingCount,
      percentage: calculatePercentage(pendingCount),
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    {
      label: 'Declined',
      count: declinedCount,
      percentage: calculatePercentage(declinedCount),
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20'
    },
    {
      label: 'Total Sent',
      count: totalInvitations,
      percentage: 100,
      icon: 'Mail',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats?.map((stat) => (
        <div
          key={stat?.label}
          className={`bg-card border ${stat?.borderColor} rounded-lg p-4 transition-smooth hover-lift`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`flex items-center justify-center w-10 h-10 ${stat?.bgColor} rounded-lg`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold text-foreground">{stat?.count}</p>
              <p className={`text-xs font-medium ${stat?.color}`}>{stat?.percentage}%</p>
            </div>
          </div>
          <p className="text-sm font-medium text-muted-foreground">{stat?.label}</p>
          {stat?.label !== 'Total Sent' && (
            <div className="mt-2 w-full bg-muted rounded-full h-1.5">
              <div
                className={`h-1.5 rounded-full ${stat?.bgColor?.replace('/10', '')}`}
                style={{ width: `${stat?.percentage}%` }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default InvitationStats;